<div id="top-el"></div>
<div class="row se-progress-bar" *ngIf="totalPage && activePage">
    <div class="col-sm-12">
        <self-evaluation-progressbar-component
                                               [step]="step"
                                               [activePage]="activePage"
                                               [total]="totalPage">
        </self-evaluation-progressbar-component>
    </div>
</div>
<div tabindex="0" class="wrapper wrapper__selfevaluation"
     [ngStyle]="deviceInnerHeight > 0 ?
        {
            'min-height': deviceInnerHeight + 'px'
        } : ''"
     [ngClass]="{ 'wrapper--detail-step' : (step < selfEvaluationService.pageTypes[type]['showFeedbackStep'] && step > 0) || rated != 0 }" [class.hidden]="isLoading">
    <div class="row hidden">
        {{ deviceInfor }}
    </div>
    <div class="col-xs-12 wrapper__introduction__image hidden-sm-up" *ngIf="step >= 0 && !isFinishSR">
        <img *ngIf="selfEvaluationService.showFeedback; else notFinishMobile" class="img-fluid" src="assets/img/self-evaluation/step-{{step}}-1.png">
        <ng-template #notFinishMobile>
            <img *ngIf="!selfEvaluationService.showFeedback" class="img-fluid" src="assets/img/self-evaluation/step-{{step}}.png">
        </ng-template>
    </div>


    <div class="row header-title" [class.hidden]="!headerTitle">
        <div class="col-sm-12">
            <h1 *ngIf="headerTitle" class="wrapper__title font-se-title" id="se-title" [innerHTML]="headerTitle"></h1>
        </div>
    </div>
    <div class="row wrapper__introduction" *ngIf="appService.activeLanguage">
        <div class="col-xs-12 col-sm-8">
            <div *ngIf="!selfEvaluationService.isRedirectedFromAmnestic || isStudy; else agreementHeader"
                 [class.hidden]="step == selfEvaluationService.pageTypes[type]['showFeedbackStep']">
                <ng-container *ngFor="let content of contentHeader | keyvalue">
                    <div class="second-header font-se-title-small"
                         *ngIf="step != 0  && step != selfEvaluationService.pageTypes[type]['showFeedbackStep']"
                         [class.hidden]= "step == -1 || content.key != step">
                        <ng-container *ngIf="isAdditionalStep; else normalStepHeader">
                            {{ contentHeader[step + '-additional'] | translate }}
                        </ng-container>
                        <ng-template #normalStepHeader>
                            {{ content.value | translate }}
                        </ng-template>
                    </div>
                </ng-container>
                <ng-container *ngFor="let content of contentBody | keyvalue">
                    <div class="content-step content-step-{{ content.key }}"
                         [class.hidden]=" step >= selfEvaluationService.pageTypes[type]['steps']['FEEDBACK']
                                            || step === selfEvaluationService.pageTypes[type]['steps']['FEELING_RATING']
                                            || step == -1
                                            || content.key != step">
                        <ng-container *ngIf="isAdditionalStep; else normalStep">
                            <span class="wrapper__introduction__content additionalStep {{ step + '-additional' }}">{{ contentBody[step + '-additional'] | translate }}</span>
                        </ng-container>
                        <ng-template #normalStep>
                            <span class="wrapper__introduction__content normalStep">{{ content.value | translate }}</span>
                        </ng-template>
                    </div>
                </ng-container>

                <div [class.hidden]= "step != -1">
                    <span class="wrapper__introduction__content">
                        {{ 'For further information, please contact the person or institution who sent you this link for further information.' | translate }}
                    </span>
                </div>
            </div>
            <ng-template #agreementHeader>
                <div class="second-header font-se-title-small" >{{ 'Sending the self-evaluation' | translate }}</div>
                <span [innerHTML]="contentForScientificAgree[0]"></span>
                <ng-container *ngIf="contentForScientificAgree[1] && contentForScientificAgree[2]">
                    <span tabindex="0" class="wrapper__introduction__link" (click)="onpenScientificDialog()">{{ contentForScientificAgree[1] }}</span>
                    <span [innerHTML]="contentForScientificAgree[2] | safeHtml"></span>
                </ng-container>

                <div class="row">
                    <div class="col-xs-12 agreement-accordion mt-2">
                        <div tabindex="0" class="agreement-accordion--group" *ngFor="let item of agreementAccordion.header; let i = index" (keyup.enter)="toggleAccordion(accordion)" (click)="toggleAccordion(accordion)">
                            <div class="agreement-accordion--group__header" #accordion>
                                <button tabindex="-1" class="btn btn-link pull-left">
                                    <i class="fal" [ngClass]="{'fa-angle-right': !accordion || !accordion['show'], 'fa-angle-down': accordion && accordion['show']}"></i>
                                </button>
                                <div id="agreement-{{ i }}" class="pull-left">
                                    <span> {{ item | translate}} </span>
                                </div>
                            </div>
                            <div tabindex="0" class="agreement-accordion--group__content" [class.hidden]="!accordion ||!accordion['show']" [innerHTML]="agreementAccordion.content[i] | translate | safeHtml">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-1 agreement-checkbox">
                    <div class="col-xs-12" tabindex="0" role="checkbox" (keyup.enter)="isAgree = !isAgree">
                        <input tabindex="-1" type="checkbox" value="0" id="agreement-scientific" [(ngModel)]="isAgree">
                        <label for="agreement-scientific" class="lbl-a">
                            {{'I hereby consent to Klenico Health AG processing my health data in anonymous form' | translate}}
                        </label>
                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-xs-12">
                        <strong>
                            {{ 'If you have any questions or would like additional information, please contact' | translate}}: datenschutz@klenico.com
                        </strong>
                    </div>
                </div>
            </ng-template>
            <div class="wrapper__introduction__content" [class.hidden]="step !== selfEvaluationService.pageTypes[type]['showFeedbackStep'] || selfEvaluationService.isRedirectedFromAmnestic">
                <ng-container *ngIf="selfEvaluationService.showFeedback">
                    {{ contentBody[selfEvaluationService.pageTypes[type]['showFeedbackStep']] | translate }}
                </ng-container>
                <ng-container *ngIf="!selfEvaluationService.showFeedback">
                    {{ contentBody[6] | translate }}
                </ng-container>
            </div>
        </div>
        <div class="col-xs-12 col-sm-4" *ngIf="haveHarming && harmingTemplate">
            <div class="harming-box">
                <div class="harming-box_body harming-box_body--header">{{ harmingTemplate.header }}</div>
                <div class="harming-box_body harming-box_body--content" [innerHTML]="harmingTemplate.content"></div>
                <div class="harming-box_body harming-box_body--link">
                    <a href="{{ harmingTemplate.link }}" target="_blank" rel="noopener">
                        <i class="fas fa-arrow-right"></i>
                        {{ 'Call now' | translate }}
                    </a>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-4 wrapper__introduction__image hidden-xs-down" *ngIf="step >= 0 && !isFinishSR">
            <img *ngIf="selfEvaluationService.showFeedback; else notFinish" class="img-fluid" src="assets/img/self-evaluation/step-{{step}}-1.png">
            <ng-template #notFinish>
                <img *ngIf="!selfEvaluationService.showFeedback" class="img-fluid" src="assets/img/self-evaluation/step-{{step}}.png">
            </ng-template>
        </div>
    </div>
    <div class="row wrapper__feedback-rating" [class.hidden]="!selfEvaluationService.showFeedback">
        <div class="col-xs-12 col-md-5  mr-t--md">
            <div tabindex="0" class="wrapper__feedback-rating__area">
                <ng-container *ngFor="let contentHeader of contentHeaderFeedback; let i = index">
                    <i tabindex="0" aria-label="'Rating' | translate + ' 1'" *ngIf="i > 0" class="fa-star rating-item" [ngClass]="(rated >= i ) ? 'fas':'far'" (click)="setRated(i)" (keyup.enter)="setRated(i)"></i>
                </ng-container>

                <div class="col-xs-12 rating-header" *ngIf="rated != 0">
                    {{ contentHeaderFeedback[rated] | translate }}
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-md-8 mr-t--md" [class.hidden]="rated == 0">
            <textarea id="patient-comment" maxlength="300" placeholder="{{ 'Your comment' | translate }}" #patientComment class="form-control comment-area" #commentTextarea rows="6"></textarea>
        </div>
    </div>
    <div class="row wrapper__btns" [class.hidden]="(selfEvaluationService.showFeedback && rated != 0) || step === -1">
        <div class="col-xs-12 slide-navigator">
            <!-- Button for First Overview Page -->
            <ng-container *ngIf="step == 0; else normalStepBtns">
                <div class="row">
                    <div class="col-xs-3">
                        <button type="submit"
                                class="btn badge-pill pd-v--sm btn-primary btn-xs-full pull-left--important"
                                (click)=beginQuestionnaires()>
                            {{ 'Start Self-Evaluation' | translate }}
                        </button>
                    </div>
                    <div class="col-xs-3 hidden">
                        <button type="submit"
                                class="btn badge-pill pd-v--sm btn-xs-full pull-left--important"
                                (click)=beginQuestionnaires()>
                            <i class="fal fa-play-circle"></i>
                            {{ 'Watch explanation video' | translate }}
                        </button>
                    </div>
                </div>
                <div class="row mr-t--lg footer--ce">
                    <div class="col-sm-6 col-xs-12">
                        <img class="img-fluid pull-left mr-r--sm" src="assets/img/self-evaluation/CE.png">
                        {{ 'Certified and CE-approved medical device' | translate }}
                    </div>
                </div>
            </ng-container>

            <ng-template #normalStepBtns>
                <button *ngIf="step < selfEvaluationService.pageTypes[type]['showFeedbackStep']
                            && !selfEvaluationService.isRedirectedFromAmnestic
                            && !isLoading"
                        type="submit"
                        class="btn badge-pill pd-v--sm btn-primary btn-xs-full pull-right mr-l--sm"
                        (click)=beginQuestionnaires()>
                    <i class="fas fa-check"></i>
                    {{ 'Next' | translate }}
                </button>

                <button *ngIf="step < selfEvaluationService.pageTypes[type]['showFeedbackStep'] && step > 0 && !selfEvaluationService.isRedirectedFromAmnestic"
                        (click)="openConfirm()" type="submit"
                        class="btn btn--continue bg--none br--none badge-pill pd-v--sm btn-xs-full pull-right text-regular continue-later-btn">
                    <i class="fal fa-pause-circle"></i>
                    {{ 'Continue later' | translate }}
                </button>

                <div *ngIf="selfEvaluationService.isRedirectedFromAmnestic && !isStudy">
                    <button type="submit" class="pull-left--important mr-r--xs btn btn-min badge-pill pd-v--sm btn-primary btn-xs-full"
                            (click)="endResearchAgreement()">
                        <i class="fas fa-check"></i>
                        {{ "Complete" | translate }}
                    </button>

                    <a [attr.tabindex]="-1" class="pull-left" [class.disabled--click]="!isAgree" href="/assets/files/scientific-agreement-{{appService.activeLanguage.locale}}.pdf" target="_blank" rel="noopener">
                        <button [attr.tabindex]="!isAgree ? -1 : 0" type="submit" class="btn btn--tertiary bg--none br--none badge-pill pd-v--sm btn-xs-full text-regular">
                            <i class="fas fa-arrow-to-bottom"></i>
                            {{ 'Download' | translate }}
                        </button>
                    </a>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="row wrapper__btns wrapper__send-feedback-btn" *ngIf="selfEvaluationService.showFeedback && rated != 0">
        <div class="col-xs-12 slide-navigator">
            <button [class.hidden]="!(selfEvaluationService.showFeedback && rated != 0)" (click)="sendFeedback()" (keyup.enter)="sendFeedback()" type="submit" class="btn btn-primary badge-pill pd-v--sm btn-xs-full pull-left--important">
                <i class="fas fa-clock"></i>
                {{ 'Send feedback' | translate }}
            </button>
        </div>
    </div>
</div>

<self-evaluation-confirm-modal-component #confirmModal [isStudy]= "isStudy" (confirmContinueLater)="continueLaterSubmit()" [isIntroducePage]="true" [step]="step"></self-evaluation-confirm-modal-component>

<div bsModal #modalScientificInfor="bs-modal" class="modal fade self-evaluation-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <i class="fas fa-times close-btn" (click)="modalScientificInfor.hide()"></i>
                <div class="row self-evaluation-modal__header">
                    <div class="col-xs-9">
                        <span class="">{{ researchAgreementTitle }}</span>
                    </div>
                </div>
                <div class="row self-evaluation-modal__body">
                    <div class="col-sm-9" [innerHTML]="researchAgreement">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<dialog-component #dialog></dialog-component>
